import axios from 'axios';
import { debugLog } from '@/helpers/loggingFunctions.js';
import * as authFunctions from '@/helpers/authFunctions.js';
import { router } from '@/routes/router';

export const axiosAdapter = axios.create();

// Simple dynamic base URL for /my/pre-qualify/
if (!window.BASE) {
  window.BASE = '/my/pre-qualify/';
}
axiosAdapter.defaults.baseURL = window.BASE;

axiosAdapter.actOnApiErrorResponse = async function (error) {
    // debugLog('helpers/axiosAdapter - This method parses and acts upon a returned API error');

    let { data } = error ?? {};

    return error;
};

axiosAdapter.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // debugLog('resources/js/helpers/axiosAdapter.js - error!!');

        // comment this for now because we don't need to redirect to the login page on every logout

        // if (error?.response?.status === 401) {
        //     authFunctions.clearStores();
        //     router.push({ name: 'auth.login' });
        // }
        return Promise.reject(error);
    }
);
